import { Colors } from '@kvika/theme';
import * as React from 'react';
import { StyledBarSpinner } from './styles/BarSpinnerStyles';
var BarSpinner = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? 'kvika-spinner' : _b, _c = _a.color, color = _c === void 0 ? Colors.gold600 : _c, className = _a.className;
    return (React.createElement(StyledBarSpinner, { "data-testid": testId, color: color, className: className },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
};
export default BarSpinner;
//# sourceMappingURL=BarSpinner.js.map